import { Injectable } from '@angular/core';
import { Permit } from '../ViewModel/Permit';
import { Comment } from '../ViewModel/comment';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MyPermitsViewModel, MyPermitRootOIbject } from '../ViewModel/MyPermitsViewModel';
import { HelperService } from './helper.service';
import { HierarchyTree } from '../ViewModel/HierarchyTree';
import { SecurityDashboardRootObject, ClosedByRoleName } from '../ViewModel/SecurityDashboardViewModel';
import { Common } from '../ViewModel/Common';
import { ParentAsset } from '../ViewModel/VMAsset';
import { PermitIdentifier } from '../ViewModel/PermitIdentifier';
import { LinkedPermitViewModel, ManualPermitTypeViewModel } from '../ViewModel/LinkedPermitViewModel';
import { ManualPermitType } from '../ViewModel/ManualPermitType';
import { EntityAsset } from '../ViewModel/DASModels/EntityAssetModel';
import { PermitState } from '../ViewModel/PermitState';
import { LinkedPermits } from '../ViewModel/LinkedPermits';
import { PaperPermit } from '../ViewModel/paperpermit';
import { BulkPermitStateUpdateRequest, BulkPermitStateUpdateResponse } from '../ViewModel/BulkPermitStateUpdate';

@Injectable({
  providedIn: 'root'
})
export class PermitService {
 _common = new Common();
  constructor(private _http: HttpClient, private _helperService: HelperService) { }
  private _permitUrl = environment.WEBAPIURL + 'permits/permit';
  private _linkpermitUrl = environment.WEBAPIURL + 'masterpermit/link-permit';
  private _permitsBasedOnPermitTypeUrl = environment.WEBAPIURL + 'permits/permit-type';
  private _permitCountUrl = environment.WEBAPIURL + 'permits/permit-type';
  private _myPermitsUrl = environment.WEBAPIURL + 'permits/my-permits/';
  private _getAllIdentifiers = environment.WEBAPIURL + 'permits/permit-identifier-all/';
  private _filterPermits = environment.WEBAPIURL + 'permits/permit-identifier-filter/';
  private _permitComments = environment.WEBAPIURL + 'permit-comment';
  private _cseRegisterUrl = environment.WEBAPIURL + 'cse-register'
  private _securityDashboardPermitsURL = environment.WEBAPIURL + 'permits/security-dashboard-permits'
  private _permitStatusUrl = environment.WEBAPIURL + 'permits/permit-status';
  private _sendMailUrl = environment.WEBAPIURL + 'permits/mail';
  private _updateEntryleaderUrl = environment.WEBAPIURL + 'permits/permit-entryLeader';
  private _EAMProcURL = environment.WEBAPIURL + 'permits/Cse-Asset';
  private _EAMNonCSEAssetURL = environment.WEBAPIURL + 'permits/NonCse-Asset';
  private _EAMWorkOrderURL = environment.WEBAPIURL + 'permits/work-order';
  private _EAMOPSeqURL = environment.WEBAPIURL + 'permits/op-sequence';
  private _sectionEditorURL = environment.WEBAPIURL + 'permits/getEditorDetails';
  private _NonCSEParentAssetURL = environment.WEBAPIURL + 'permits/non-cse-parent-asset';
  private _NonCSEChildAssetURL = environment.WEBAPIURL + 'permits/non-cse-child-asset';
  private _NonCSEAssetSearchURL = environment.WEBAPIURL + 'permits/non-cse-asset-search';
  private _permitIdentifierUrl = environment.WEBAPIURL + 'permits/permit-identifier';
  private _permitIdentifierByTabUrl = environment.WEBAPIURL + 'permits/permit-identifier-filters';
  private _getAllPermitsUrl = environment.WEBAPIURL + 'permits/getAllPermits';
  private _getDashboardClosedByRoleUrl = environment.WEBAPIURL + 'permits/dashboard-pending-role';
  private _unlinkPermitUrl = environment.WEBAPIURL + 'masterpermit/unlink-permit';
  private _manualPermitUrl = environment.WEBAPIURL + 'masterpermit/manual-permits';
  private _digitalPermitUrl = environment.WEBAPIURL + 'masterpermit/digital-permits';
  private _copymanualpermitsUrl= environment.WEBAPIURL + 'masterpermit/copy-manual-permits'
  private _updateManualPermitUrl = environment.WEBAPIURL + 'masterpermit/update-manual-permits';
  private _addManualPermitUrl = environment.WEBAPIURL + 'masterpermit/add-manual-permits';
  private _entityAssetUrl = environment.WEBAPIURL + 'common/get-uploaded-file';
  private _paperPermitUrl = environment.WEBAPIURL + 'paperpermit/add';
  private _getPaperPermitUrl = environment.WEBAPIURL + 'paperpermit/get';
  private _updatePaperPermitUrl = environment.WEBAPIURL + 'paperpermit/update';

  getAllPermits() {
    return this._http.get<Permit[]>(this._permitUrl);
  }

  getAllPermitStatus()
  {
    return this._http.get<PermitState[]>(this._permitStatusUrl);
  }
  getPermit(permitId) {
    let loginId = localStorage.getItem("_loginId");
    let params = new HttpParams()
      .set("loginId", loginId ?? '')
      .set("permitId", permitId.toString());
    return this._http.get<Permit>(this._permitUrl, { params: params });
  }

  getPaperPermit(permitId) {
    return this._http.get<PaperPermit>(this._getPaperPermitUrl + '/' + permitId);
  }

  getDigitalPermits(masterpermitId)
  {
    return this._http.get<LinkedPermits[]>(this._digitalPermitUrl,
      {params: new HttpParams().append('masterPermitId', masterpermitId.toString())});
  }

  getManualPermits(masterPermitId) {
    return this._http.get<ManualPermitType[]>(this._manualPermitUrl,
      {params: new HttpParams().append('masterPermitId', masterPermitId.toString())});
  }
  updateManualPermit(manualPermit : ManualPermitType, operation : string) {
    return this._http.post(this._updateManualPermitUrl, manualPermit,
      {params: new HttpParams().append('operation', operation)});
  }
  updatePaperPermit(paperPermit : PaperPermit) {
    return this._http.put(this._updatePaperPermitUrl, paperPermit);
  }
  getAssetDetails(siteId) {
    return this._http.get<any[]>(this._cseRegisterUrl + '/' + siteId);
  }
  addPermit(permit: Permit) {
    return this._http.post<Permit>(this._permitUrl, permit, { observe: 'response' });
  }

  updatePermit(permit: Permit) {
    return this._http.put(this._permitUrl, permit, { observe: 'response' });
  }
  updateEntryLeaderQuestion(permit: Permit) {
    return this._http.put(this._updateEntryleaderUrl, permit, { observe: 'response' });
  }

  updatePermitState(permitTypeId, permitId, permitStateId) {
    let languageId = localStorage.getItem("_languageID");
    return this._http.put(this._permitUrl + '/' + permitTypeId + '/' + permitId + '/' + permitStateId + '/' + languageId, { observe: 'response' });
  }

  bulkUpdatePermitState(request: BulkPermitStateUpdateRequest) {
    return this._http.put<BulkPermitStateUpdateResponse>(environment.WEBAPIURL + 'permits/bulkUpdateState', request);
  }

  addPaperPermit(data) {
    return this._http.post<string>(this._paperPermitUrl, data);
  }

  addManualPermits(data) {
    return this._http.post<string>(this._addManualPermitUrl, data);
  }
  getPermitsByPermitType(permitTypeId: number,_userSiteId:number=0 ,pageIndex:number=0,rowsCount:number=0) {
    let languageId = localStorage.getItem("_languageID");
    return this._http.get<Permit[]>(this._permitsBasedOnPermitTypeUrl + '/' + permitTypeId + '/' + languageId+'/'+_userSiteId+'/'+pageIndex+'/'+rowsCount)
  }
  getSingleImageAsset(pictureUrl: string) {
    return this._http.get<any>(`${this._entityAssetUrl}/${pictureUrl}`);
  }
  getAllIdentifiers(permitTypeId: number) {
    return this._http.get<Permit[]>(this._getAllIdentifiers + permitTypeId+'/'+parseInt(localStorage.getItem("_languageID")))
  }
  getPermitCount(permitTypeId: number,_userSiteId:number=0 ) {
    let languageId = localStorage.getItem("_languageID");
    return this._http.get<Permit[]>(this._permitCountUrl + '/' + permitTypeId + '/' + languageId+'/'+_userSiteId)
  }

  getMyPermits(loginIdList: string[],startIndex, endIndex) {
    let languageId = localStorage.getItem("_languageID");
    let params = new HttpParams().set("loginIds", this._helperService.EscapeSpecialCharacters(JSON.stringify(loginIdList)));
    return this._http.get<MyPermitRootOIbject>(this._myPermitsUrl + languageId+ '/' + startIndex + '/' + endIndex, { params: params });
  }
  
  getPermitComments(permitId) {
    return this._http.get<Comment[]>(this._permitComments + '/' + permitId);
  }

  filterPermits(_filters) {
    return this._http.post<Comment[]>(this._filterPermits, _filters, { observe: 'response' });
  }
  addPermitComment(comment) {
    return this._http.post<Comment[]>(this._permitComments, comment, { observe: 'response' });
  }

  linkPermit(linkPermitObj: LinkedPermitViewModel){
    return this._http.post(this._linkpermitUrl, linkPermitObj,{observe: 'response'});
  }
  copyManualpermits(manualpermitObj :ManualPermitTypeViewModel)
  {
    return this._http.post(this._copymanualpermitsUrl, manualpermitObj,{observe: 'response'});
  }
  unlinkPermit(unlinkPermitObj: LinkedPermitViewModel){
    return this._http.post(this._unlinkPermitUrl, unlinkPermitObj,{observe: 'response'});
  }
  getPermitDetails(selectedHierarchy: any, startIndex, endIndex, loginId, globalFilter, isMyAction, isAllPermits, isMasterPermit, isChildPermit, masterPermitId, allMasterPermits, typeIds, statusIds, areaIds, dateRange,
    identifier1_Ids,identifier1_Val,identifier2_Ids,identifier2_Val,identifier3_Ids,identifier3_Val,identifier4_Ids,identifier4_Val,identifier5_Ids,identifier5_Val,identifier6_Ids,identifier6_Val,identifier7_Ids,identifier7_Val) {
    selectedHierarchy.languageId = localStorage.getItem("_languageID");
    selectedHierarchy.LogInId = localStorage.getItem("_loginId");
    selectedHierarchy.StartIndex = startIndex;
    selectedHierarchy.EndIndex = endIndex;
    selectedHierarchy.CreatedBy = loginId;
    selectedHierarchy.GlobalFilter = globalFilter;
    selectedHierarchy.MyAction = isMyAction;
    selectedHierarchy.AllPermits = isAllPermits;
    selectedHierarchy.MasterPermit= isMasterPermit;
    selectedHierarchy.ChildPermit = isChildPermit;
    selectedHierarchy.MasterPermitId = masterPermitId;
    selectedHierarchy.AllMasterPermits = allMasterPermits;
    selectedHierarchy.MyPermits = (isMyAction == false && isAllPermits == false && isMasterPermit==false && isChildPermit==false) ? true : false;    
    selectedHierarchy.PermitTypeIds = typeIds;
    selectedHierarchy.PermitStateIds = statusIds;
    selectedHierarchy.AreaIds = areaIds;
    selectedHierarchy.DateRange = dateRange;
    selectedHierarchy.identifier1_Ids=identifier1_Ids;
    selectedHierarchy.identifier1_Val=identifier1_Val;
    selectedHierarchy.identifier2_Ids=identifier2_Ids;
    selectedHierarchy.identifier2_Val=identifier2_Val;
    selectedHierarchy.identifier3_Ids=identifier3_Ids;
    selectedHierarchy.identifier3_Val=identifier3_Val;
    selectedHierarchy.identifier4_Ids=identifier4_Ids;
    selectedHierarchy.identifier4_Val=identifier4_Val;
    selectedHierarchy.identifier5_Ids=identifier5_Ids;
    selectedHierarchy.identifier5_Val=identifier5_Val;
    selectedHierarchy.identifier6_Ids=identifier6_Ids;
    selectedHierarchy.identifier6_Val=identifier6_Val;
    selectedHierarchy.identifier7_Ids=identifier7_Ids;
    selectedHierarchy.identifier7_Val=identifier7_Val;
    return this._http.post<SecurityDashboardRootObject>(this._securityDashboardPermitsURL, selectedHierarchy, { observe: 'response' });
  }

  getPermitStatus(permitId) {
    let languageId = localStorage.getItem("_languageID");
    return this._http.get<any>(this._permitStatusUrl + '/' + permitId + '/' + languageId);
  }

  sendConfiguredEmail(permitId, azureFileId) {
    return this._http.get<any>(this._sendMailUrl + '/' + permitId + '/' + azureFileId);
  }
  getProcedureDetailsFromEAM(assetNo: string, siteId)
  {
     return this._http.get<any>(this._EAMProcURL + '/' + assetNo + '/' + siteId);
  }
  getAssetDetailsFromEAM(filterText,siteId,startIndex, endIndex)
  {
     return this._http.get<any>(this._EAMProcURL + '/' +filterText + '/' + siteId + '/' + startIndex + '/' + endIndex );
  }
  getNonCSEAssetDetailsFromEAM(filterText,siteId,startIndex, endIndex)
  {
     return this._http.get<any>(this._EAMNonCSEAssetURL + '/' +filterText + '/' + siteId + '/' + startIndex + '/' + endIndex );
  }
  getWorkOrderFromEAM(assetNo,filterText,siteId,startIndex, endIndex)
  {
     return this._http.get<any>(this._EAMWorkOrderURL + '/' + assetNo + '/' +filterText + '/' + siteId + '/' + startIndex + '/' + endIndex );
  }
  getOperationSequence(woNo: string[], filterText, siteId, startIndex, endIndex) {
    let woStringify = this._helperService.EscapeSpecialCharacters(woNo.join('@@@'));
    return this._http.get<any>(this._EAMOPSeqURL + '/' + woStringify + '/' + filterText + '/' + siteId + '/' + startIndex + '/' + endIndex);
  }
  getEditorsDetails(permitId, stateId){
    return this._http.get<any>(this._sectionEditorURL + '/' + permitId + '/' + stateId);
  }
  getNonCSEParentAsset(siteId: string){
    return this._http.get<any>(this._NonCSEParentAssetURL + '/' + siteId);
  }
  getNonCSEChildAsset(siteId: string, assetNumber: string){
    return this._http.get<any>(this._NonCSEChildAssetURL + '/' + siteId + '/' + assetNumber);
  }
  getNonCSEAssetSearch(searchText: string, siteId: string, pageIndex: string, pageSize: string){
    const params = new HttpParams().set('searchText', searchText);
  return this._http.get<any>(
    `${this._NonCSEAssetSearchURL}/${siteId}/${pageIndex}/${pageSize}`,
    { params }
  );
  }
 
  getPermitIdentifier_MasterData(identifierQRef: string) {
    let params = new HttpParams().set("identifierQRef", identifierQRef);
    return this._http.get<PermitIdentifier[]>(this._permitIdentifierUrl, { params: params })
  }
  getPermitIdentifierByTabs(siteId: string, tabName: string, loginId: string, languageId: string, identifierQRef: string){
    let params = new HttpParams()
                  .set("siteId", siteId)
                  .set("tabName", tabName)
                  .set("loginId", loginId)
                  .set("languageId", languageId)
                  .set("identifierQRef", identifierQRef);
    return this._http.get<PermitIdentifier[]>(this._permitIdentifierByTabUrl, { params: params });
  }
  getAllPermitsByPermitTypeId(permitTypeId: number,_userSiteId:number=0 ) {
    let languageId = localStorage.getItem("_languageID");
    return this._http.get<Permit[]>(this._getAllPermitsUrl + '/' + permitTypeId +'/'+_userSiteId+ '/' + languageId);    
  }
  getDashboardClosedByRole(searchOptions: string, languageId: number) {
    let params = new HttpParams()
                  .set("searchOptions", this._helperService.EscapeSpecialCharacters(searchOptions))
                  .set("languageId", languageId.toString());
    return this._http.get<ClosedByRoleName[]>(this._getDashboardClosedByRoleUrl, { params: params })
  }

}
